"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFormLabel = void 0;
exports.MuiFormLabel = {
    root: {
        marginBottom: 4,
        '&$focused': {
            color: 'inherit',
        },
    },
};
